export default __webpack_public_path__ + "static/media/user-no-photo.593db832.svg";